<template>
  <div class="content-container">
    <div class="breadcrumb-wrapper clearfix"></div>
    <div class="paper-container clearfix ">
      <div class="paper-main ">
        <div class="paper-content">
          <div class="paper-body f-usn">
            <div class="paper-part" id="questionId">
              <div
                class="paper-section"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="question-type">
                  <h4 class="type-title color-3">
                    <span class="order">一.</span
                    ><span class="edit-text"> {{ item.type_name }} </span
                    ><span
                      >（共
                      <strong class="num">{{ item.count }}</strong>
                      小题）</span
                    >
                  </h4>
                </div>
                <div class="paper-section-list-box">
                  <div v-for="(n, i) in item.question" :key="i">
                    <div class="question-wrapper">
                      <div class="question-container">
                        <div class="question-content">
                          <div class="ques-origin">
                            <div>
                              <div class="ques-topic">
                                {{ i + 1 }}.
                                <span
                                  class="ques-type"
                                  v-html="n.topic"
                                ></span>
                              </div>
                            </div>
                            <ul
                              class="ques-option"
                              style="display: flex; align-items: flex-end; flex-wrap: wrap;"
                              v-if="n.option"
                            >
                              <li
                                v-for="(value, key) in n.option"
                                :key="key"
                                v-html="optionHtml(key, value)"
                              ></li>
                            </ul>
                          </div>
                        </div>
                        <div class="question-operate clearfix">
                          <div class="operate-item">
                            <span
                              class="operate-btn check-btn"
                              @click="onInfo(n.question_id)"
                              >详情</span
                            >
                          </div>
                          <div class="operate-item">
                            <span
                              class="operate-btn delete-btn"
                              @click="onDelete(n.question_id)"
                              >删除</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="paper-body-close-view">
          <i class="el-icon-view"></i><span>关闭预览</span>
        </div>
        <div class="paper-body-sort">
          <i class="el-icon-sort"></i><span>保存排序</span>
        </div> -->
      </div>
      <div class="paper-side fl">
        <div class="paper-edit">
          <div class="edit-header">
            <h3 class="edit-title color-3 font-16">试题统计</h3>
            <span class="paper-empty" @click="onCleanQuestion"
              ><i class="iconfont iconnonebg-delete"></i
              ><span class="text">清空</span></span
            >
          </div>
          <div class="edit-sum">
            <!-- <span class="item">分数：<em class="num">0</em></span> -->
            <span class="item"
              >题数：<em class="num">{{ totalCount }}</em></span
            >
          </div>
          <div class="edit-body">
            <div class="edit-part">
              <div v-for="(m, k) in list" :key="k">
                <div class="edit-item">
                  <div class="edit-item-top">
                    <strong class="type color-3"
                      ><span class="order">一. </span
                      ><span class="text">{{ m.types_name }}</span></strong
                    >
                    <div class="edit-operate">
                      <span
                        class="operate-btn delete-btn"
                        @click="onDeleteQuestion(m.types_code)"
                        >删除</span
                      >
                    </div>
                  </div>
                  <div class="edit-item-content">
                    <ul class="item-num-body clearfix">
                      <li
                        class="item-num-box J_drag_grid"
                        v-for="(item, index) in m.question"
                        :key="index"
                      >
                        <span class="num">{{ index + 1 }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="edit-footer">
            <button
              type="button"
              class="el-button btn btn-light el-button--default"
              @click="onGo"
            >
              <span>继续选题</span>
            </button>
          </div>
          <div class="edit-footer">
            <button
              type="button"
              class="el-button btn btn-light save-but el-button--default"
              @click="dialogFormVisible = true"
            >
              <span>保存试卷</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="保存试卷" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item label="试题名称" label-width="100px" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onFormSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
Vue.prototype.optionHtml = function(i, v) {
  // to do
  let html = ["A", "B", "C", "D"];
  return html[i] + "." + v;
};
import Sortable from "sortablejs";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        name: "",
      },
      list: [],
      totalCount: 0,
      dialogFormVisible: false,
      rules: {
        name: [{ required: true, message: "请输入试题名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["stageSubject"]),
  },
  created() {
    this.stageCode =
      this.$route.query.stagecode || this.stageSubject.stage.id;
    this.subjectCode =
      this.$route.query.subjectcode || this.stageSubject.subject.id;
    this.code = this.$route.query.code || "";
    this.form.name =
      this.$route.query.name === "undefined" ? "" : this.$route.query.name;
    this.getBasketList();
  },
  methods: {
    getBasketList() {
      this.getRequest("/wenjiaoopne/kc/basket/work/getBasketList", {
        stage_id: this.stageCode,
        subject_id: this.subjectCode,
      })
        .then((result) => {
          this.list = result.data.list;
          this.totalCount = result.data.total_count;
          this.mathJaxInit();
        })
        .catch(() => {});
    },
    onInfo(qids) {
      this.$router.push(`/work/detail/${qids}`);
    },
    onDelete(qids) {
      this.postRequest("/wenjiaoopne/kc/basket/work/remove", {
        question_id: qids,
        stage_id: this.stageCode,
        subject_id: this.subjectCode,
      })
        .then(() => {
          this.getBasketList();
        })
        .catch(() => {});
    },
    onGo() {
      this.$router.push("/work/knowledge");
    },
    onFormSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.postRequest("/wenjiaoopne/kc/basket/work/setUserPaper", {
            code: this.code,
            name: this.form.name,
            stage_id: this.stageCode,
            subject_id: this.subjectCode,
          })
            .then((result) => {
              if (result.data) {
                this.$message.success(result.message);
                this.dialogFormVisible = false;
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    onDeleteQuestion(code) {
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.postRequest("/wenjiaoopne/kc/basket/work/delete", {
            type_id: code,
            stage_id: this.stageCode,
            subject_id: this.subjectCode,
          })
            .then(() => {
              this.getBasketList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onCleanQuestion() {
      this.$confirm("确定要清空吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.postRequest("/wenjiaoopne/kc/basket/work/clean", {
            stage_id: this.stageCode,
            subject_id: this.subjectCode,
          })
            .then(() => {
              this.getBasketList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    mathJaxInit() {
      this.$nextTick(()=> {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("questionId"); //传入组件id，让组件被MathJax渲染
        });
    },
  },
  mounted() {
    // 上下拖动列表
    let el = document.querySelectorAll(".edit-body")[0];
    let _thisTypes = this;
    _thisTypes.sortable = Sortable.create(el, {
      onEnd({ newIndex, oldIndex }) {
        console.log(newIndex, oldIndex);
      },
    });
  },
};
</script>
<style scoped>
.ques-origin .ques-option {
  width: 100%;
}
.ques-origin .ques-option > li {
  display: inline-block;
  line-height: 34px;
  padding-right: 50px;
  color: #333;
  font-size: 14px;
}
.ques-origin .ques-option > li > span {
  padding-right: 50px;
}
.ques-origin .ques-topic {
  padding-bottom: 5px;
  color: #333;
  line-height: 24px;
}
.ques-origin .ques-topic .sub-index {
  padding-left: 20px;
}
.ques-origin .ques-analysis,
.ques-origin .ques-answer {
  line-height: 24px;
  padding: 6px 0;
  color: #666;
  font-size: 14px;
}
.ques-origin .ques-type {
  margin-bottom: 10px;
  color: #333;
  font-size: 14px;
}
.ques-origin .q-l.ques-type {
  margin-left: 20px;
}
.ques-title {
  margin-left: -8px;
}
.ques-crow {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.question-container {
  position: relative;
  border: 1px solid transparent;
  cursor: move;
  background: #fff;
}
.question-container:hover {
  border: 1px solid #41b9f1;
}
.question-container:hover .question-operate {
  display: block;
}
.question-container > .question-content {
  padding: 18px 9px;
}
.question-container.question-hide {
  cursor: default;
}
.question-container.question-hide:hover {
  border: 1px solid #fff;
}
.question-active .question-container {
  border: 1px solid #41b9f1;
}

.question-operate {
  position: absolute;
  top: -28px;
  right: -1px;
  overflow: hidden;
  border-left: 1px solid #41b9f1;
  display: none;
  height: 28px;
}
.question-operate .operate-item {
  display: inline-block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  border-right: 1px solid #41b9f1;
  border-top: 1px solid #41b9f1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  cursor: pointer;
}
.question-operate .operate-item .operate-btn {
  color: #41b9f1;
  font-size: 12px;
}
.question-operate .operate-item:hover {
  background: #41b9f1;
}
.question-operate .operate-item:hover .operate-btn {
  color: #fff;
}
.question-operate .operate-item-set {
  background: #eceff3;
  border-bottom: 1px solid #41b9f1;
}
.question-operate .operate-item-set .set-input {
  float: left;
  width: 50px;
  height: 18px;
  line-height: 18px;
  margin: 4px 0 4px 6px;
  background: #fff;
  text-align: center;
  color: #333;
  font-size: 12px;
}
.question-operate .operate-item-set:hover {
  background: #eceff3;
}
.operate-cp-number-input {
  width: 55px;
}
.operate-cp-number-input .el-input__inner {
  font-size: 12px;
  width: 45px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
}
.paper-part .paper-section.active {
  background: #fbfbfb;
}
.paper-part .paper-title {
  position: relative;
  margin: 24px 0;
}
.paper-part .paper-title .title {
  height: 42px;
  line-height: 42px;
  margin-bottom: 5px;
  background: #f6f6f6;
  text-align: center;
}
.paper-part .paper-title .title .edit-input {
  padding: 11px 0;
  font-size: 16px;
}
.paper-part .paper-title .paper-rule {
  height: 28px;
  line-height: 28px;
}
.paper-part .paper-title .paper-rule .edit-input {
  text-align: left;
}
.paper-part .question-type {
  position: relative;
  max-height: 88px;
  margin-bottom: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.paper-part .question-type .score-table {
  display: inline-block;
  vertical-align: middle;
  margin: 8px;
  margin-right: 22px;
}
.paper-part .question-type .score-table td,
.paper-part .question-type .score-table tr {
  height: 35px;
}
.paper-part .question-type .score-table td,
.paper-part .question-type .score-table th {
  width: 70px;
  border: 1px solid #e2e2e2;
  font-size: 12px;
  text-align: center;
  font-weight: 400;
}
.paper-part .question-type .type-title {
  line-height: 30px;
  margin-left: 8px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.paper-part .question-type .type-title .edit-input {
  width: 80px;
  margin-left: 5px;
  padding: 3px;
}
.paper-part .edit-text {
  cursor: pointer;
  border: 1px solid transparent;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.paper-part .edit-input,
.paper-part .edit-text:hover {
  background: #f3f7fb;
  border: 1px solid #e2e2e2;
}
.paper-part .edit-input {
  width: 100%;
  padding: 6px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.paper-operate {
  height: 205px;
  background: #fff;
  margin-bottom: 16px;
  padding: 30px 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.paper-operate .item {
  margin-bottom: 16px;
}
.paper-operate .item .btn {
  width: 113px;
  height: 40px;
  padding: 0;
  font-size: 14px;
}
.paper-operate .item .btn:first-child {
  margin-right: 6px;
}
.paper-operate .item .btn.btn-border {
  color: #333;
}
.paper-operate .item .btn-border {
  border: 1px solid #e2e2e2;
}
.paper-operate .item .btn-border.is-disabled:hover {
  color: #333;
  font-size: 14px;
  background: #fff;
}
.paper-operate .item .btn-border:hover {
  border: 1px solid #41b9f1;
  color: #41b9f1;
}
.paper-operate .item-download .btn,
.paper-operate .item-save .btn {
  width: 100%;
}
.paper-edit .edit-header {
  padding: 16px 8px 14px 8px;
}
.paper-edit {
  position: relative;
  background: #fff;
  padding: 0 6px 30px 6px;
}
.paper-edit .edit-sum {
  padding: 0 8px 8px;
  font-size: 12px;
}
.paper-edit.fixed-edit {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 270px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 700px;
}

.edit-item {
  position: relative;
  background: #fff;
  padding: 13px 9px 0 9px;
  border: 1px solid transparent;
  overflow: hidden;
  cursor: move;
}
.edit-item:hover {
  border: 1px solid #41b9f1;
}
.paper-edit .edit-header .edit-title {
  display: inline-block;
}
.paper-edit .edit-header .paper-empty {
  float: right;
  color: #619cf5;
  font-size: 12px;
  cursor: pointer;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.edit-item.edit-item-drag {
  z-index: 1000;
  border: 1px dashed #41b9f1;
  background: #f6f6f6;
}
.paper-edit .edit-footer .btn-light {
  width: 100%;
  height: 100%;
  font-size: 14px;
  margin: 5px 0;
}
.save-but {
  background-color: #41b9f1;
  color: #fff;
}
.edit-item .edit-item-top .edit-operate {
  float: right;
}
.edit-item .edit-item-top .edit-operate .operate-btn {
  -webkit-transition: 0.2s;
  transition: 0.2s;
  font-size: 12px;
  cursor: pointer;
  color: #333;
}
.edit-item .edit-item-top .edit-operate .operate-btn:hover {
  color: #41b9f1;
}
.edit-item .edit-item-top .edit-operate .delete-btn {
  margin-left: 20px;
}
.edit-item .edit-item-content {
  padding-top: 20px;
}
.edit-item .edit-item-content .item-num-body {
  width: 252px;
  padding: 0 9px;
  margin-left: -10px;
}
.edit-item .edit-item-content .item-num-box {
  float: left;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #eceff3;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #f6f6f6;
  margin-right: 12px;
  margin-bottom: 12px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.edit-item .edit-item-content .item-num-box .num {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 12px;
}
.edit-item .edit-item-content .item-num-box:hover {
  border: 1px solid #41b9f1;
  background: #41b9f1;
}
.edit-item .edit-item-content .item-num-box:hover .num {
  color: #fff;
}

.content-container {
  background: #f1f1f1;
  min-height: 850px;
}
.paper-container {
  min-height: 825px;
  margin-bottom: 70px;
  width: 1195px;
  margin: 10px auto 0;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.paper-main {
  position: relative;
  width: 914px;
  min-height: 825px;
  background: #fff;
  margin-right: 286px;
}
.paper-content {
  padding: 82px 22px 40px 72px;
}
.paper-side {
  position: relative;
  width: 270px;
  margin-left: -270px;
}

.paper-body-close-view {
  position: absolute;
  width: 100px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  top: 10px;
  left: 10px;

  background: #fff;
  border: 1px dashed #41b9f1;
  -webkit-box-shadow: 0 8px 24px 0 rgba(101, 162, 255, 0.22);
  box-shadow: 0 8px 24px 0 rgba(101, 162, 255, 0.22);
  border-radius: 17px;
  color: #41b9f1;
  cursor: pointer;
}
.paper-body-sort {
  position: absolute;
  width: 100px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  top: 10px;
  right: 10px;
  background: #fff;
  border: 1px dashed #41b9f1;
  -webkit-box-shadow: 0 8px 24px 0 rgba(101, 162, 255, 0.22);
  box-shadow: 0 8px 24px 0 rgba(101, 162, 255, 0.22);
  border-radius: 17px;
  color: #41b9f1;
  cursor: pointer;
}
.paper-body-close-view > i {
  padding-right: 5px;
}

.fl {
  float: left;
}
</style>
